<template>
    <div>
        <div class="position-input-container">
            <form-checkbox 
                class="configuration-item"
                label="Show axis tick"
            />
            <form-checkbox 
                class="configuration-item"
                label="Align tick with label"
            />
            
            <form-input-float 
                label="Axis Tick Length"
                size="mini" 
                :inputValue.sync="axis_length"
            ></form-input-float>
        </div>
    </div>
</template>

<script>
import FormLabelTitle from '@/components/Form/FormLabelTitle'
import FormInputFloat from '@/components/Form/FormInputFloat'
import FormCheckbox from '@/components/Form/FormCheckbox'

    export default {
        components: {
            'form-checkbox': FormCheckbox,
            'form-label-title': FormLabelTitle,
            'form-input-float': FormInputFloat,
        },
        props: {
            left: {
                type: String | Number
            },
            top: {
                type: String | Number
            },
            right: {
                type: String | Number
            },
            length: {
                type: String | Number
            },
        },
        computed: {
            left_value: {
                set(val){
                    this.$emit('update:left', val)
                },
                get(){
                    return this.left
                }
            },
            top_value: {
                set(val){
                    this.$emit('update:top', val)
                },
                get(){
                    return this.top
                }
            },
            right_value: {
                set(val){
                    this.$emit('update:right', val)
                },
                get(){
                    return this.right
                }
            },
            axis_length: {
                set(val){
                    this.$emit('update:length', val)
                },
                get(){
                    return this.length
                }
            },
        },
    }
</script>

<style scoped>
.position-input-container {
    display: grid;
    grid-gap: 10px;
    margin: 8px 0 16px 0;
}
.position-item-input-container {
    display: flex;
    align-items: center;
}
.position-label {
    font-size: 11px;
    color: var(--description-grey);
}
.position-label-left-col {
    width: 60px;
}
.position-label-right-col {
    width: 90px;
}
</style>


// WEBPACK FOOTER //
// src/components/SidebarDetail/EchartConfiguration/AxisTick.vue